export default __webpack_public_path__ + "static/media/bored-buddha-shot.1a2d12bf.png";